import React from "react";
import Header from "../../../components/common/header/header";
import { Container, Stack, Tab, Tabs } from "react-bootstrap";
import Settlements from "./Settlements";
import AllOrder from "./Orders/AllOrder";
import AllReconRequests from "./ReconRequests/AllReconRequests";

function Rsf() {
  return (
    <div>
      <Header />
      <Container fluid>
        <Stack gap={3} className="mt-3">
          <h4>Beta Ondc RSF</h4>
          <Tabs
            defaultActiveKey="settlements"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="settlements" title="Settlements">
              <Settlements />
            </Tab>
            <Tab eventKey="allorder" title="All-Orders">
              <AllOrder />
            </Tab>
            <Tab eventKey="reconrequests" title="Recon Requests">
              <AllReconRequests />
            </Tab>
          </Tabs>
        </Stack>
      </Container>
    </div>
  );
}

export default Rsf;
